import React, { Fragment } from "react";
import IntlMessages from "Util/IntlMessages";
import BreadcrumbContainer from "Components/BreadcrumbContainer";
import { Row, Card, CardBody, Col } from "reactstrap";
import { Separator } from "Components/CustomBootstrap";

function BlankPage() {
  return (
    <Fragment>
      <Row>
        <Col xs="12">
          <BreadcrumbContainer heading={<IntlMessages id="menu.blank-page" />} />
          <Separator className="mb-5" />
        </Col>
      </Row>
      <Row>
        <Col lg="12" className="mb-5">
          <Card>
            <CardBody>Your Content...</CardBody>
          </Card>
        </Col>
      </Row>
    </Fragment>
  );
}

export default BlankPage;
